// AccessibilityPanel.jsx
import { useState } from 'react';
import Modal from '../Modal/Modal';
import Button from '../Button/Button';
import { useAccessibility } from '../../context/AccessibilityContext/AccessibilityContext';
import style from './accessibilitypanel.module.scss';
import { FaEye } from 'react-icons/fa';

const AccessibilityPanel = () => {
  const { settings, setSettings } = useAccessibility();
  const [isActive, setIsActive] = useState(false);

  const handleSettingChange = (key, value) => {
    setSettings(prev => ({ ...prev, [key]: value }));
  };

  return (
    <div className={style.accessibilityPanel}>
      <button
        aria-label="Режим для слабовидящих"
        onClick={() => setIsActive(true)}
        className={style.iconButton}
      >
        <FaEye className={style.blindIcon} />
      </button>
      
      <Modal
        active={isActive}
        setActive={setIsActive}
        width='fit-content'
        height='fit-content'
        padding='16px'
      >
        <div className={style.wrapper}>
          <div className={style.section}>
            <h4>Размер текста:</h4>
            <div className={`${style.buttonsGroup} ${style.fontSizeGroup}`}>
              <Button
                width='30%'
                text="A"
                active={settings.fontSize === 'default'}
                onClick={() => handleSettingChange('fontSize', 'default')}
              />
              <Button
                width='30%'
                text="A+"
                active={settings.fontSize === 'large'}
                onClick={() => handleSettingChange('fontSize', 'large')}
              />
              <Button
                width='30%'
                text="A++"
                active={settings.fontSize === 'xlarge'}
                onClick={() => handleSettingChange('fontSize', 'xlarge')}
              />
            </div>
          </div>
          
          <div className={style.section}>
            <h4>Цветовая схема:</h4>
            <div className={style.buttonsGroup}>
              <Button
                width='48%'
                text="Обычная"
                active={settings.contrast === 'default'}
                onClick={() => handleSettingChange('contrast', 'default')}
              />
              <Button
                width='48%'
                text="Контрастная"
                active={settings.contrast === 'light'}
                onClick={() => handleSettingChange('contrast', 'light')}
              />
            </div>
          </div>
          
          <div className={style.section}>
            <h4>Изображения:</h4>
            <div className={style.buttonsGroup}>
              <Button
                width='48%'
                text="Показывать"
                active={settings.images}
                onClick={() => handleSettingChange('images', true)}
              />
              <Button
                width='48%'
                text="Скрыть"
                active={!settings.images}
                onClick={() => handleSettingChange('images', false)}
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AccessibilityPanel;